"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.estimateTxFee = void 0;
const js_buildTransaction_1 = require("./js-buildTransaction");
const js_createTransaction_1 = __importDefault(require("./js-createTransaction"));
const utils_1 = require("./utils");
const logs_1 = require("@ledgerhq/logs");
function estimateTxFee(api, account, kind) {
    return __awaiter(this, void 0, void 0, function* () {
        const tx = createDummyTx(account, kind);
        const [onChainTx] = yield (0, js_buildTransaction_1.buildTransactionWithAPI)(account, tx, api);
        const fee = yield api.getFeeForMessage(onChainTx.message);
        if (typeof fee !== "number") {
            (0, logs_1.log)("error", `api.getFeeForMessage returned invalid fee: <${fee}>`);
            // TEMP HACK: sometimes fee is not a number, retrying with a next blockhash
            return retryWithNewBlockhash(api, onChainTx);
        }
        return fee;
    });
}
exports.estimateTxFee = estimateTxFee;
const createDummyTx = (account, kind) => {
    switch (kind) {
        case "transfer":
            return createDummyTransferTx(account);
        case "stake.createAccount":
            return createDummyStakeCreateAccountTx(account);
        case "stake.delegate":
            return createDummyStakeDelegateTx(account);
        case "stake.undelegate":
            return createDummyStakeUndelegateTx(account);
        case "stake.withdraw":
            return createDummyStakeWithdrawTx(account);
        case "stake.split":
        case "token.createATA":
        case "token.transfer":
            throw new Error(`not implemented for <${kind}>`);
        default:
            return (0, utils_1.assertUnreachable)(kind);
    }
};
const createDummyTransferTx = (account) => {
    return Object.assign(Object.assign({}, (0, js_createTransaction_1.default)({})), { model: {
            kind: "transfer",
            uiState: {},
            commandDescriptor: Object.assign({ command: {
                    kind: "transfer",
                    amount: 0,
                    recipient: account.freshAddress,
                    sender: account.freshAddress,
                } }, commandDescriptorCommons),
        } });
};
const createDummyStakeCreateAccountTx = (account) => {
    return Object.assign(Object.assign({}, (0, js_createTransaction_1.default)({})), { model: {
            kind: "stake.createAccount",
            uiState: {},
            commandDescriptor: Object.assign({ command: {
                    kind: "stake.createAccount",
                    amount: 0,
                    delegate: {
                        voteAccAddress: randomAddresses[0],
                    },
                    fromAccAddress: account.freshAddress,
                    seed: "",
                    stakeAccAddress: randomAddresses[1],
                    stakeAccRentExemptAmount: 0,
                } }, commandDescriptorCommons),
        } });
};
const createDummyStakeDelegateTx = (account) => {
    return Object.assign(Object.assign({}, (0, js_createTransaction_1.default)({})), { model: {
            kind: "stake.delegate",
            uiState: {},
            commandDescriptor: Object.assign({ command: {
                    kind: "stake.delegate",
                    authorizedAccAddr: account.freshAddress,
                    stakeAccAddr: randomAddresses[0],
                    voteAccAddr: randomAddresses[1],
                } }, commandDescriptorCommons),
        } });
};
const createDummyStakeUndelegateTx = (account) => {
    return Object.assign(Object.assign({}, (0, js_createTransaction_1.default)({})), { model: {
            kind: "stake.undelegate",
            uiState: {},
            commandDescriptor: Object.assign({ command: {
                    kind: "stake.undelegate",
                    authorizedAccAddr: account.freshAddress,
                    stakeAccAddr: randomAddresses[0],
                } }, commandDescriptorCommons),
        } });
};
const createDummyStakeWithdrawTx = (account) => {
    return Object.assign(Object.assign({}, (0, js_createTransaction_1.default)({})), { model: {
            kind: "stake.withdraw",
            uiState: {},
            commandDescriptor: Object.assign({ command: {
                    kind: "stake.withdraw",
                    amount: 0,
                    authorizedAccAddr: account.freshAddress,
                    stakeAccAddr: randomAddresses[0],
                    toAccAddr: randomAddresses[1],
                } }, commandDescriptorCommons),
        } });
};
const commandDescriptorCommons = {
    errors: {},
    fee: 0,
    warnings: {},
};
// pregenerate for better caching
const randomAddresses = [
    "HxCvgjSbF8HMt3fj8P3j49jmajNCMwKAqBu79HUDPtkM",
    "AjmMiagw33Ad4WdPR3y2QWsDXaLxmsiSZEpMfpT1Q9uZ",
    "AVHhsobqNw3b3XD43fz7Crq3d3UxFYZfHAByh7ogZoeN",
    "FvbvvXMY4Rf1AtGG7UHJUesjt8FFgPnPy6o83Dna9mXK",
    "AEtRo9MKfLqGtjvxdz8H93R7SQxXLEkibVSJbs9XKnD1",
];
function retryWithNewBlockhash(api, onChainTx) {
    return __awaiter(this, void 0, void 0, function* () {
        if (onChainTx.message.recentBlockhash === undefined) {
            throw new Error("expected recentBlockhash");
        }
        onChainTx.message.recentBlockhash = yield waitNextBlockhash(api, onChainTx.message.recentBlockhash);
        const fee = yield api.getFeeForMessage(onChainTx.message);
        if (typeof fee !== "number") {
            throw new Error(`unexpected fee: <${fee}>, after retry with a new blockhash`);
        }
        return fee;
    });
}
function sleep(durationMS) {
    return new Promise(res => setTimeout(res, durationMS));
}
function waitNextBlockhash(api, currentBlockhash) {
    return __awaiter(this, void 0, void 0, function* () {
        const sleepTimeMS = 5000;
        for (let i = 0; i < 5; i++) {
            (0, logs_1.log)("info", `sleeping for ${sleepTimeMS} ms, waiting for a new blockhash`);
            yield sleep(sleepTimeMS);
            const blockhash = yield api.getLatestBlockhash();
            if (blockhash !== currentBlockhash) {
                (0, logs_1.log)("info", "got a new blockhash");
                return blockhash;
            }
            (0, logs_1.log)("info", "got same blockhash");
        }
        throw new Error("next blockhash timeout");
    });
}
//# sourceMappingURL=tx-fees.js.map